import { useEffect, useState } from "react";
import { WHEEL_SPIN_MS } from "entities/wheel-raffle";
import type { WheelState } from "entities/wheel-raffle";

const getSpinMs = (): number =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ? 0
    : WHEEL_SPIN_MS;

// Крутим, когда розыгрыш прошёл на глазах у зрителя: по кнопке Start или
// по истечении таймера (он разыгрывает так же). Итоги показываем после
// остановки, чтобы колесо не отставало от результата.
export const useWheelSpin = (isDrawn: boolean) => {
  const [prevDrawn, setPrevDrawn] = useState(isDrawn);
  const [isSpinning, setIsSpinning] = useState(false);

  // Состояние меняем при рендере: иначе итоги мелькнут на один кадр.
  if (isDrawn !== prevDrawn) {
    setPrevDrawn(isDrawn);
    if (isDrawn) setIsSpinning(true);
  }

  useEffect(() => {
    if (!isSpinning) return;
    const timer = setTimeout(() => setIsSpinning(false), getSpinMs());
    return () => clearTimeout(timer);
  }, [isSpinning]);

  const getWheelState = (): WheelState => {
    if (isSpinning) return "spinning";
    return isDrawn ? "stopped" : "idle";
  };

  return {
    isSpinning,
    isRevealed: isDrawn && !isSpinning,
    wheelState: getWheelState(),
  };
};
